export default function Toast({ message, onClose }) {
  if (!message) return null;

  return (
    <div
      className="fixed right-4 top-4 z-50 max-w-sm rounded-xl border bg-white px-4 py-3 shadow-lg
                 dark:bg-gray-950 dark:border-gray-800"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-sm text-gray-800 dark:text-gray-100">{message}</div>
        <button
          type="button"
          onClick={onClose}
          className="rounded px-2 py-1 text-xs text-gray-600 hover:bg-gray-100
                     dark:text-gray-300 dark:hover:bg-gray-800"
          aria-label="Close toast"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
